const MultiOrderSelect = require('../multi_order_select');
const {
  store: ShippingLabelStore,
  actions: ShippingLabelActions,
} = require('../shipping_label_form_module');
const { mapStateToProps } = require('@reverbdotcom/discovery-ui');

function mapper() {
  const {
    relatedOrders,
    selectedOrders,
  } = ShippingLabelStore.getState();

  return {
    relatedOrders,
    selectedOrders,
    toggleOrderSelected: ShippingLabelActions.toggleOrderSelected,
    addAllRelatedOrders: ShippingLabelActions.addAllRelatedOrders,
    removeAllRelatedOrders: ShippingLabelActions.removeAllRelatedOrders,
  };
}

module.exports = mapStateToProps({
  mapper, stores: [ShippingLabelStore],
})(MultiOrderSelect, 'MultiOrderSelect');



// WEBPACK FOOTER //
// ./javascripts/components/shipping_labels/containers/multi_order_select_container.jsx